import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUsername, storeEventUserId, setCountry, setNoOfViewers } from '../../redux/actions/authActions';
import Nav from './s2tranNav/S2tranNav'
import S2txtBody from './s2txtBody/S2txtBody';
import Helmet from 'react-helmet'
import './S2txtMain.scss'
import { setLanguageText } from '../../redux/actions/s2txtActions';
import { database } from '../../utils/firebase';
import { useHistory } from 'react-router';


const S2txtMainFile = ({match}) => {
    const [loading, setLoading] = useState(true);
    const user = useSelector(state => state.user)
    const dispatch = useDispatch()
    const { lvcconnectEventUserId } = user
    const [eventsData, setEventsData] = useState([])
    const [eventID, setEventID] = useState('')
    const [userData, setUserData] = useState('')
    const [eventUsers, setEventUsers] = useState([])
    const history = useHistory()


    const closeNav = () => {
        document.querySelector('.lang-c').classList.add('hide')
        document.querySelector('.backgroundh').classList.add('hide')
        document.querySelector('.nav-bar').classList.add('hide') 
        document.querySelector('.stream-form-container').classList.add('hide') 
        document.querySelector('.stream-give').classList.add('hide') 
        document.querySelector('.nav-bg').classList.add('hide') 
    }

    useEffect(() => {
        const eventRef = database.ref('Events')

        eventRef.on('value', (el) => {
            let eData = []
            for (let id in el.val()) {
                eData.push({id, ...el.val()[id]})
            }

            if (eData.length !== eventsData.length) {
                setEventsData(eData)
            } 
            

            
        })

        const check = eventsData.some(el => {
            return el.eventStatus === 'Live'
        })

        if(check) {
            eventsData.forEach(el => {
                if (el.eventStatus === 'Live') {
                    setEventID(el.id)
                    return
                }
            })
        }
        if (!check) {
            eventsData.forEach(el => {
                if (el.eventStatus === 'Default') {
                    setEventID(el.id)
                    return
                }
            })  
                
            }

            console.log(eventID)
    }, [eventsData])

    useEffect(() => {
        if(eventID) {
            const eventRef = database.ref('Events').child(eventID).child('Users')
            eventRef.on('value', (el) => {
                let eData =[] 
                for (let id in el.val()) {
                    eData.push({id, ...el.val()[id]})
                }
                    if(eData.length === 0) {
                        setEventUsers(['null'])
                    } else {
                        setEventUsers(eData)
                    }
                    
        })
        }
    }, [eventID])

    useEffect(() => {
        if(eventID) {


            if (match.params.id) {

                dispatch(storeEventUserId(match.params.id))
                if(eventUsers.length > 0) {

                    const bb = eventUsers.some(el => {return el.id === match.params.id})
                    if (bb) {
                        const eventRef = database.ref('Events').child(eventID).child('Users').child(match.params.id)
                        eventRef.on('value', (el) => {
                            setUserData(el.val())
                        })
                    } else {
                        history.push('/')
                        // window.location = 'http://localhost:3000/'
                    }
                } 
                
              
                
            } else if (lvcconnectEventUserId) {

                if(eventUsers.length > 0) {
                    
                    const bb = eventUsers.some(el => {return el.id === lvcconnectEventUserId})
                    if (bb) {
                        const eventRef = database.ref('Events').child(eventID).child('Users').child(lvcconnectEventUserId)
                        eventRef.on('value', (el) => {
                            setUserData(el.val())
                        })
                    } else {
                        history.push('/')
                        // window.location = 'http://localhost:3000/'
                        
                    }
                } 
                
            } else {
                history.push('/')
                // window.location = 'http://localhost:3000/'
            }
        }
        

    }, [dispatch, eventID, eventUsers, lvcconnectEventUserId, match.params.id])

    

    useEffect(() => {
        if (userData) {
            dispatch(setCountry(userData.country))
            dispatch(setUsername(userData.name))
            dispatch(setLanguageText(userData.preferredLanguage))
            dispatch(setNoOfViewers(userData.noOfViewers))
            setLoading(false)
        }
        
        
    }, [dispatch, userData]);

    useEffect(()=>{
        const nextURL = '/stream';
        const nextTitle = 'LVZStream';
        const nextState = { additionalInformation: '' };
        // This will replace the current entry in the browser's history, without reloading
        window.history.replaceState(nextState, nextTitle, nextURL)
    }, [])

     
    if(loading) {
        return (
            <div className='loading'>
                <div className="load-container">
                    <div class="fancy-spinner">
                        <div class="ring"></div>
                        <div class="ring"></div>
                        <div class="dot"></div>
                    </div>
                </div>
                
            
                <Helmet htmlAttributes>
                    <meta charSet="utf-8" />
                    <html lang="en" />
                    <title>Stream | LVZConnect</title>
                    <meta name="description" content="LVZConnect Streaming Page" />
                </Helmet>
               
            </div>
        )
    }

    if (!loading) {
        return ( 
            <div className='s2txtMain'>
                <Helmet htmlAttributes>
                    <meta charSet="utf-8" />
                    <html lang="en" />
                    <title>Stream | LVZConnect</title>
                    <meta name="description" content="LVZConnect Streaming Page" />
                </Helmet>
                <div className='background backgroundh hide' onClick={closeNav}></div>
                <Nav /> 
                <S2txtBody />
                <footer className='admin-footer'>
                    <p>Made with ❤️ by Virtual Church Team. LVZ Connect! A Group Church of CELVZ © 2021. <br />All rights reserved.</p>
                </footer>
            </div>
        )
    }
    
    
}

export default S2txtMainFile